/**
 * NotasEditorLazy — fronteira de code-split do editor Milkdown.
 *
 * ProseMirror/Milkdown é pesado; só carrega quando uma reunião entra ao vivo (fullscreen
 * ou compacto). `import type` mantém o boundary (não puxa o módulo pro bundle principal).
 * Encaminha o ref (NotasEditor é forwardRef) e mostra um skeleton no lugar da caixa.
 */
import { forwardRef, lazy, Suspense } from 'react'
import type { NotasEditorHandle, NotasEditorProps } from './NotasEditor'

const NotasEditorImpl = lazy(() => import('./NotasEditor'))

function NotasSkeleton({ className }: { className?: string }) {
  return (
    <div className={className} role="status" aria-busy="true" aria-label="Carregando editor de notas">
      <div className="flex items-center gap-2 p-4 text-[11px] text-[#555]">
        <span className="material-symbols-outlined animate-spin text-sm">progress_activity</span>
        Carregando editor…
      </div>
    </div>
  )
}

const NotasEditorLazy = forwardRef<NotasEditorHandle, NotasEditorProps>(
  function NotasEditorLazy(props, ref) {
    return (
      <Suspense fallback={<NotasSkeleton className={props.className} />}>
        <NotasEditorImpl ref={ref} {...props} />
      </Suspense>
    )
  },
)

export default NotasEditorLazy
